import { createPortal } from 'react-dom'
import { useEscapeKey } from '@/hooks/use-escape-key'
import type { Media } from '@/models/media'
import type { CoverSpec } from '@/lib/cover-spec'
import { MyMedia } from './MyMedia'

interface MediaPickerOverlayProps {
  onClose: () => void
  onSelect: (media: Media | null) => void
  /** When set, uploads are cropped to this shape and its size is suggested. */
  coverSpec?: CoverSpec
}

/**
 * The media library as a modal, layered over whatever opened it.
 *
 * Every cover field needs this, and each of them previously rendered `MyMedia`
 * inline — so the picker appeared *beside* the form it was for rather than over
 * it. Portalled so it sits above its parent overlay regardless of stacking
 * context.
 */
export function MediaPickerOverlay({ onClose, onSelect, coverSpec }: MediaPickerOverlayProps) {
  useEscapeKey(onClose)

  return createPortal(
    <div
      className="overlay-container media-picker"
      role="dialog"
      aria-modal="true"
      aria-label="Choose an image"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose()
      }}
    >
      <div className="overlay-wrapper">
        <div className="content">
          <div className="section-title">Choose an image</div>
          <MyMedia selecting onClose={onClose} onSelect={onSelect} coverSpec={coverSpec} />
        </div>
      </div>
    </div>,
    document.body,
  )
}
